import React from 'react';

interface WarningIconProps {
  color?: string;
  size?: string;
}

export const WarningIcon = ({size = '25', color = '#FDB455'}: WarningIconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25ZM13.6561 15.1406L13.985 5.37863H11.0052L11.3341 15.1406H13.6561ZM12.4952 19.6206C12.966 19.6206 13.3449 19.482 13.632 19.2046C13.919 18.9273 14.0625 18.5757 14.0625 18.15C14.0625 17.7179 13.919 17.3632 13.632 17.0858C13.3449 16.8085 12.966 16.6698 12.4952 16.6698C12.0308 16.6698 11.6551 16.8101 11.368 17.0906C11.081 17.3712 10.9375 17.7243 10.9375 18.15C10.9375 18.5757 11.081 18.9273 11.368 19.2046C11.6551 19.482 12.0308 19.6206 12.4952 19.6206Z" fill={color}/>
    </svg>
  );
};

export default WarningIcon;
